import { Tables } from '../../components';

import {AdminVillageApi} from "gmrfid-service-community-api-manager"

import moment from 'moment';
import { useEffect, useState } from 'react';
import { gmrfidCode } from '../../utils';
import { Wrap } from './style';
import QueryForm from './query';
import Add from './add';
import DetailsModal from './details';
import { AnimationModal } from '@/components';
import RelationModal from './modal';
import defaultSettings from '@/defaultSettings';
import store from '@/store';

const ProjectManage = () => {
  const [appState, appDispatchers] = store.useModel('app');
  const { appConfig } = appState;
  const [fields, setFields] = useState({});
  const [tableTime, setTableTime] = useState('');
  const [tableObj, setTableObj] = useState({});
  const [villageObj, setVillageObj] = useState({});
  const [visible, setVisible] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [mode, setMode] = useState('multiple');
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [bindType, setBindType] = useState();
  const queryDetailsFn = (record) => {
    AdminVillageApi.platformBaseInfo({
      param: {
        id: record?.id,
      },
    }).then((res) => {
      if (res && res.status === 200) {
        setVisible(true);
        setTableObj({
          ...record,
          ...res.data,
        });
      }
    });
  };

  const columns = [
    {
      title: '序号',
      dataIndex: 'num',
      render: (text) => <span>{text}</span>,
      width: '8%',
    },
    {
      title: '项目名称',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      isShowTitle: true,
      width: '15%',
    },
    {
      title: '所属行政区划',
      dataIndex: 'province',
      key: 'province',
      align: 'left',
      width: '30%',
      render: (text, record) => {
        return (
          <span>
            {`${text || ''}/${record.city || ''}/${record.area || ''}/${record.street || ''}/${record.community || ''}`}
          </span>
        );
      },
    },
    {
      title: '创建人',
      dataIndex: 'creatorName',
      key: 'creatorName',
      align: 'left',
      width: '12%',
    },
    {
      title: '创建时间',
      dataIndex: 'createDate',
      key: 'createDate',
      align: 'left',
      width: '15%',
      render: (text) => text && moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: '认证状态',
      dataIndex: 'verifyState',
      key: 'verifyState',
      align: 'left',
      width: '12%',
      render: (text) => {
        return (
          <span
            style={{
              color: text === 'STOP' ? '#44BB55' : '#666666',
            }}
          >
            {gmrfidCode.projectManageState[text]}
          </span>
        );
      },
    },
    {
      title: '套餐',
      dataIndex: 'comboObj',
      align: 'left',
      key: 'comboObj',
      width: '15%',
      render: (text, record) => {
        return <span>{record.comboObj && record.comboObj.name}</span>;
      },
    },
    {
      title: '物联绑定状态',
      dataIndex: 'comboObj',
      align: 'left',
      key: 'comboObj',
      width: '20%',
      render: (text, record) => {
        const { vlVillageName, wlVillageId } = record;
        const bool = vlVillageName && wlVillageId;
        return <span>{bool ? `已绑定（${vlVillageName}）` : '未绑定'}</span>;
      },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      align: 'left',
      key: 'operation',
      width: '25%',
      render: (text, record) => {
        const { vlVillageName, wlVillageId } = record;
        const bool = vlVillageName && wlVillageId;
        return (
          <ul className="operation">
            <li
              onClick={() => {
                queryDetailsFn(record);
              }}
            >
              详情
            </li>
            <i />
            <li
              onClick={() => {
                setTableObj(record);
                setShowDrawer(true);
                setMode('single');
              }}
            >
              配置套餐
            </li>
            <i />
            <li
              onClick={() => {
                setTableObj(record);
                if (bool) {
                  setBindType(false);
                  setVisible1(true);
                } else {
                  setVisible2(true);
                  setBindType(true);
                }
              }}
            >
              {bool ? '解绑物联' : `关联${appConfig.title_1}`}
            </li>
          </ul>
        );
      },
    },
  ];

  const relieveFn = () => {
    AdminVillageApi.bindWL({
      form: {
        bind: bindType,
        villageId: tableObj?.id,
        vlVillageName: tableObj?.vlVillageName || villageObj?.estateName,
        wlVillageId: tableObj?.wlVillageId || villageObj?.id,
      },
    }).then((res) => {
      setVisible1(false);
      setVisible2(false);
      setTableObj({});
      setVillageObj({});
      setTableTime(Math.random());
    });
  };

  return (
    <Wrap>
      <QueryForm setFields={setFields} setMode={setMode} setShowDrawer={setShowDrawer} />
      <div className="tableBox">
        <Tables
          // scroll={{ x: 'max-content' }}
          columns={columns}
          pagination={false}
          newPagination
          fields={fields}
          tableTime={tableTime}
          parameterName="param"
          combo
          queryTableList={AdminVillageApi.platformList}
        />
      </div>
      {showDrawer && (
        <Add
          setShowDrawer={setShowDrawer}
          showDrawer={showDrawer}
          tableObj={tableObj}
          setTableTime={setTableTime}
          setTableObj={setTableObj}
          mode={mode}
        />
      )}
      {visible && (
        <DetailsModal
          setShowDrawer={setVisible}
          showDrawer={visible}
          setTableObj={setTableObj}
          gmrfidCode={gmrfidCode}
          tableObj={tableObj}
        />
      )}
      {visible1 && (
        <AnimationModal
          width={480}
          title={'提醒'}
          isFooter
          closeCallback={() => {
            setVisible1(false);
          }}
          ZIndex={1001}
          confirmCallback={() => {
            relieveFn();
          }}
        >
          {!villageObj?.estateName && (
            <div className="tip-text">确认{`"${tableObj?.vlVillageName}"`}小区解除物联关联？</div>
          )}
          {villageObj?.estateName && (
            <div className="tip-text">确认与{`"${villageObj?.estateName}"`}小区进行物联绑定？</div>
          )}
        </AnimationModal>
      )}
      {visible2 && (
        <AnimationModal
          width={800}
          title={`关联${appConfig.title_1}`}
          isFooter={false}
          closeCallback={() => {
            setVisible2(false);
          }}
          confirmCallback={() => {}}
        >
          <RelationModal setVisible1={setVisible1} setTableObj={setVillageObj} />
        </AnimationModal>
      )}
    </Wrap>
  );
};

export default ProjectManage;
